import React from 'react';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";


const NextBackButtonBar = ({onNext, onBack, nextButtonType, nextText='Next'})=> {

    return (
        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={3}>
                <Button variant="contained" fullWidth onClick={onBack}>
                    Back
                </Button>
            </Grid>
            <Grid item xs={3}>

            </Grid>
            <Grid item xs={6}>
                <Button type={nextButtonType} variant="contained" color="primary" onClick={onNext} fullWidth>
                    {nextText}
                </Button>
            </Grid>
        </Grid>
    );
}

export default NextBackButtonBar;